(function () {
    'use strict';
    angular.module('app').directive('selectioncommand_selectiontree', selectioncommand_selectiontree);
    selectioncommand_selectiontree.$inject = ['$window'];
    function selectioncommand_selectiontree($window) {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                selectionTreeDialogShown: '=?'
            },
            controller: 'selectiontree',
            templateUrl: 'app/selectioncommand/selectioncommand_selectiontree.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();